/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { GeoCitiesResponse } from '../../models/geo-cities-response';

export interface GeoControllerGetCities$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  name?: string;
  related_italy_region_id?: number;
  related_italy_province_id?: number;
}

export function geoControllerGetCities(http: HttpClient, rootUrl: string, params: GeoControllerGetCities$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoCitiesResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, geoControllerGetCities.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('name', params.name, {});
    rb.query('related_italy_region_id', params.related_italy_region_id, {});
    rb.query('related_italy_province_id', params.related_italy_province_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: GeoCitiesResponse;
      }>;
    })
  );
}

geoControllerGetCities.PATH = '/geo/italy/city';
